import { ApiClient } from '../../http/api_client';

export class OrderClosingDateTimeRepository {
    async getOrderClosingDateTime(
        supplierId: string,
        catalogItemCode: string,
        quantity: number,
        deliveryDestinationAddress: string,
        isUpdateCookie: boolean
    ): Promise<string> {
        const encodeCatalogItemCode = encodeURI(catalogItemCode);
        const encodeDeliveryAddress = encodeURI(deliveryDestinationAddress);

        return await ApiClient.get(
            `/p/reacquireStockDisplay/?` +
            `supplierId=${supplierId}&catalogItemCode=${encodeCatalogItemCode}&quantity=${quantity}&deliveryAddress=${encodeDeliveryAddress}
            &isUpdateCookie=${isUpdateCookie}`
        );
    }
}
